import { render, staticRenderFns } from "./WeworkDelegateConfigInfo.vue?vue&type=template&id=66b489b3&scoped=true&"
import script from "./WeworkDelegateConfigInfo.vue?vue&type=script&lang=ts&"
export * from "./WeworkDelegateConfigInfo.vue?vue&type=script&lang=ts&"
import style0 from "./WeworkDelegateConfigInfo.vue?vue&type=style&index=0&id=66b489b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b489b3",
  null
  
)

export default component.exports